export default __webpack_public_path__ + "static/media/YAS0220.34I-22781_-15215_0.d52c1333.jpg";